import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { isQaEnv } from '../../../shared/helpers/isQaEnv';

export interface QueryOrderListFilterRequest {
  page?: number;
  pageSize?: number;
  salesChannelId?: number;
  affiliateId?: number;
  orderStatus?: string;
  incompleteOrders?: boolean;
  paymentNames?: string;
  callCenterOperatorName?: string;
  sellerName?: string;
  orderId?: string;
  q?: any
  incompletedOrders?:string
  invoicedOrders?:string
  waitingOrders?:string
}

export interface PageInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface Pageable<T> {
  items: T[];
  pageInfo: PageInfo;
}

export interface QueryOrderListItemModel {
  orderId?: string;
  status?: string;
  creationDate?: string;
  details?:any
}

export interface OrderDetailsModel {
  orderId?: string;
}

export interface VtexOrderLiteModel {
  orderId: string;
  creationDate: string;
  status: string;
  salesChannel: string;
  sellers: any;
  totals: any;
  paymentData: any;
  shippingData: any;
  selectedAddresses: any;
  ratesAndBenefitsData: any;
  clientProfileData: any;
  items: any;
}

@Injectable({ providedIn: 'root' })
export class OrdersService {
  private readonly baseUrl = `${environment.backend.url}/api/vtex/orders`;

  constructor(private readonly http: HttpClient) {}

  list(req: QueryOrderListFilterRequest): Observable<Pageable<QueryOrderListItemModel>> {
      let params = new HttpParams();

  if (req.page != null) {
    params = params.set('page', req.page.toString());
  }

  if (req.pageSize != null) {
    params = params.set('pageSize', req.pageSize.toString());
  }

  if(req.incompletedOrders != null){
    params = params.set("incompletedOrders",req.incompletedOrders.toString())
  }

  if(req.invoicedOrders != null){
    params = params.set("invoicedOrders",req.invoicedOrders.toString())
  }

  if(req.waitingOrders != null){
    params = params.set("waitingOrders",req.waitingOrders.toString())
  }

  if (req.q) {
    params = params.set('q', req.q);
    return this.http.get<Pageable<QueryOrderListItemModel>>(
      `${this.baseUrl}/v1/list`,
      { params }
    );
  }

  return this.http.get<Pageable<QueryOrderListItemModel>>(
    `${this.baseUrl}/v1/list`,
    { params }
  );
  }

  detail(orderId: string): Observable<OrderDetailsModel> {
    return this.http.get<OrderDetailsModel>(`${this.baseUrl}/v1/detail/${encodeURIComponent(orderId)}`);
  }

  vtex(orderId: string): Observable<VtexOrderLiteModel> {
    return this.http.get<VtexOrderLiteModel>(`${this.baseUrl}/v1/vtex/${encodeURIComponent(orderId)}`);
  }

  gan(orderId: string): Observable<VtexOrderLiteModel> {
    return this.http.get<VtexOrderLiteModel>(`${this.baseUrl}/v1/gan/${encodeURIComponent(orderId)}`);
  }

  statistics(salesChannelId?: number): Observable<any> {
    let params = new HttpParams();
    if (salesChannelId != null) {
      params = params.set('salesChannelId', salesChannelId.toString());
    }
    return this.http.get<any>(`${this.baseUrl}/v1/statistics`, { params });
  }

  getDfdlOrder(orderId: string): Observable<any> {
    let account = "fastshopbr"
    let key = "vtexappkey-fastshopbr-NAGUNE"

    let baseurl = "custom"

    if(isQaEnv()){
      account = "fastshopbrqa2"
      key = "vtexappkey-fastshopbrqa2-MXVLHY"
      baseurl = "custom-qa"
    }
    return this.http.post<any>(`https://${baseurl}.fastshop.krzlabs.io/api/gan/orders/${encodeURIComponent(orderId)}/create/simulate`,{
      "Domain": "Marketplace",
      "OrderId": orderId,
      "State": "order-created",
      "LastState": "not-started",
      "LastChange": "2025-06-19T16:15:56.842286Z",
      "CurrentChange": "2025-06-19T16:15:56.8708426Z",
      "Origin": {
        "Account": account,
        "Key": key
      },
      "organization": "65201a17e8a8398d907c24a0"
    },
      {
    headers: {
      "x-krz-appkey":"fastshop_internal",
      "x-krz-appsecret":"27Xt080rcKqB608bxr4092gt8cvVwsRdW"
    },
        // @ts-ignore
        responseType: 'text'
      }
      );
  }

  getDfdlBilling(orderId: string): Observable<any> {
    let account = "fastshopbr"
    let key = "vtexappkey-fastshopbr-NAGUNE"
    let baseurl = "custom"

    if(isQaEnv()){
      account = "fastshopbrqa2"
      key = "vtexappkey-fastshopbrqa2-MXVLHY"
      baseurl = "custom-qa"
    }

    return this.http.post<any>(`https://${baseurl}.fastshop.krzlabs.io/api/gan/orders/${encodeURIComponent(orderId)}/billing/simulate`,{
        "Domain": "Marketplace",
        "OrderId": orderId,
        "State": "ready-for-handling",
        "LastState": "not-started",
        "LastChange": "2025-06-19T16:15:56.842286Z",
        "CurrentChange": "2025-06-19T16:15:56.8708426Z",
        "Origin": {
          "Account": account,
          "Key": key
        },
        "organization": "65201a17e8a8398d907c24a0"
      },
      {
        headers: {
          "x-krz-appkey":"fastshop_internal",
          "x-krz-appsecret":"27Xt080rcKqB608bxr4092gt8cvVwsRdW"
        },
        // @ts-ignore
        responseType: 'text'
      }


    );
  }
}
